<template>
    <AppAlert class="mt-4 p-4 inline-block !w-auto" align="left" type="warning">
        <p class="mb-2">This product has been superseded.</p>

        <p>
            View

            <Link class="cursor-pointer underline font-bold" :href="route('products.show', product)">
                <template v-if="product.brand">{{ product.brand.name }}</template>

                {{ product.name }}
            </Link>

            instead.
        </p>
    </AppAlert>
</template>

<script>
import AppAlert from "@/Components/AppAlert";
import {Link} from "@inertiajs/inertia-vue3";

export default {
    components: {AppAlert, Link},
    props: {
        product: Object
    }
};
</script>

<style scoped>

</style>
